var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.826,
    height: 15.766,
    viewBox: "0 0 17.826 15.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "detective",
    d: "M9,5A2.667,2.667,0,0,0,6.332,7.666V12.33h-2a1.333,1.333,0,1,0,0,2.666H18.993a1.333,1.333,0,1,0,0-2.666h-2V7.666A2.667,2.667,0,0,0,14.329,5Zm0,.666h5.331a1.988,1.988,0,0,1,2,2V12.33H7V7.666A1.988,1.988,0,0,1,9,5.666ZM4.333,13H18.993a.666.666,0,0,1,0,1.333H4.333a.666.666,0,1,1,0-1.333ZM6,15.6a.333.333,0,0,0-.231.573L7.1,17.5a.333.333,0,0,0,.042.033,2,2,0,1,0,3.818.365.979.979,0,0,1,1.406,0,1.98,1.98,0,0,0-.037.369,2,2,0,1,0,3.856-.729.333.333,0,0,0,.047-.037l1.334-1.326a.333.333,0,1,0-.47-.473L15.829,16.96a1.977,1.977,0,0,0-3.209.283,1.637,1.637,0,0,0-1.915,0A1.978,1.978,0,0,0,7.5,16.957L6.235,15.7A.333.333,0,0,0,6,15.6Zm3,1.333a1.333,1.333,0,1,1-1.333,1.333A1.323,1.323,0,0,1,9,16.934Zm5.331,0A1.333,1.333,0,1,1,13,18.266,1.323,1.323,0,0,1,14.329,16.934Z",
    transform: "translate(-2.75 -4.75)",
    fill: "#3b57a9",
    stroke: "#3b57a9",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.75854c3923439fc75b9fcfa0bbd90aae.svg";
export { ForwardRef as ReactComponent };